import React from "react";
import DOMPurify from "dompurify";
import {connect} from "react-redux";
import Header from "../../common/components/Header";
import {Button, Grid, Input, Modal} from "semantic-ui-react";
import {
    displayWSIDResult,
    setWSIDToState,
    showDebugModal,
    toggleModal,
    unmountTxDebugLogsPage,
    updateRegionSelection
} from "../actions/supportActions";
import { JsonViewer } from '@textea/json-viewer'
import Breadcrumb from '../../common/partials/Breadcrumb';
import {setBreadCrumb} from '../../veritas/breadcrumb/BreadcrumbActions';
import Sidebar from "../../common/components/Sidebar";
import SupportSidebarButtons from "../shared/SupportSidebarButtons";

export class TxDebugLogsPage extends React.Component {

    componentDidMount() {
        document.title = `Support - Tx-Debug Logs`;

        this.props.setBreadCrumb({
            parent: { url: '/support', text: 'Support' },
            list: { url: '/support/tx-debug-logs', text: 'TX Debug Logs' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentWillUnmount() {
        this.props.unmountTxDebugLogsPage();
    }

    // fires action to set the API region to the state.
    handleRegionSelect = (selectedOption) => {
        this.props.updateRegionSelect(selectedOption);
    }

    // fires action to set the WSID as the user types
    // most cases, will copy and paste the entire ID.
    handleSearch = (e) => {
        e.preventDefault();
        this.props.setWSID(e.target.value);
    }

    // DEV-1458 not sending the region to the API anymore.
    handleSearchClick = (e) => {
        const { WSID } = this.props;
        e.preventDefault();
        this.props.displayWSIDLogs(WSID);
    }

    // displays the debug files modal
    handleOpenDebugModal = () => {
        this.props.debugModal();
    }

    // individual method to call the action setting
    // the payload as tx to close the tx logs modal
    handleTxCloseModal = () => {
        this.props.toggleModal("tx");
    }

    // individual method to call the action setting
    // the payload as debug to close the debug files modal
    handleDebugCloseModal = () => {
        this.props.toggleModal("debug");
    }

    pageContent(){
        //DEV-1458 removing the region selection
        // Here I am not actually removing anything from the framework just disabling it
        // and changing the request to send only the WSID. This is in case if we ever want to
        // bring back the region selection it would be easier.
        return (
            <div className="support-container">
                {/*<div className="api-region-select">*/}
                {/*    <b>API Region</b>*/}
                {/*    <br/>*/}
                {/*    <Select*/}
                {/*        onChange={this.handleRegionSelect}*/}
                {/*        placeholder="Select One Region"*/}
                {/*        options={this.props.regions}*/}
                {/*        value={this.props.regionValue}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className="wsid-searchbar">
                    <b>WSID: </b>
                    <Input
                        action
                        type='text'
                        placeholder='Search Transaction Logs and Debug Files'
                        onChange={this.handleSearch}>
                        <input />
                        <Button
                            type='submit'
                            onClick={this.handleSearchClick}
                            content="Search"
                        />
                    </Input>
                </div>
            </div>
        );
    }

    render() {
        const { txModalOpen, hasDebugFiles, debugModalOpen, jsonString, htmlString } = this.props;

        return(
            <div className="support">
                <Header/>
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <SupportSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent()}
                    </Grid.Column>
                </Grid>

                {/*Primary Modal to display the TX Logs if available*/}
                <Modal
                    centered={false}
                    open={txModalOpen}
                    dimmer="blurring"
                    onClose={this.handleTxCloseModal}
                    size="fullscreen"
                >
                    <Modal.Content scrolling>
                        <JsonViewer value={jsonString} />
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color="red" inverted onClick={this.handleTxCloseModal}>
                            Close
                        </Button>

                        {/*Conditional button, active if the WSID has debug files associated to it*/}
                        {/*and acts as the trigger to the second modal.*/}
                        <Button
                            disabled={!hasDebugFiles}
                            onClick={this.handleOpenDebugModal} primary>
                            Debug Files
                        </Button>
                    </Modal.Actions>

                    {/*Second Modal to display the Debug Files if available*/}
                    <Modal
                        centered={false}
                        open={debugModalOpen}
                        dimmer="blurring"
                        onClose={this.handleDebugCloseModal}
                        size="fullscreen"
                    >
                        <Modal.Content scrolling>
                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(htmlString) }} />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button color="red" inverted onClick={this.handleDebugCloseModal}>
                                Close
                            </Button>
                        </Modal.Actions>
                    </Modal>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    regions: state.support.txDebugLogs.regions,
    regionValue: state.support.txDebugLogs.regionValue,
    txModalOpen: state.support.txDebugLogs.txModalOpen,
    debugModalOpen: state.support.txDebugLogs.debugModalOpen,
    hasDebugFiles: state.support.txDebugLogs.hasDebugFiles,
    htmlString: state.support.txDebugLogs.htmlString,
    jsonString: state.support.txDebugLogs.jsonString,
    WSID: state.support.txDebugLogs.wsid,
});

const mapDispatchToProps = dispatch => ({
    updateRegionSelect: (selectedOption) => {dispatch(updateRegionSelection(selectedOption))},
    setWSID: (wsid) => {dispatch(setWSIDToState(wsid))},
    debugModal: () => {dispatch(showDebugModal())},
    toggleModal: (typeOfModal) => {dispatch(toggleModal(typeOfModal))},
    displayWSIDLogs: (wsid) => {dispatch(displayWSIDResult(wsid))},
    unmountTxDebugLogsPage: () => {dispatch(unmountTxDebugLogsPage())},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(TxDebugLogsPage)
